import React from "react";

import Box from "@mui/material/Box";

import { useUserAuth } from "./contexts/authContext";
import { useEnv } from "./contexts/envContext";

const WeatherLegendComponents = () => {
    const { weatherOptions } = useEnv();
    const { userProfileSettings } = useUserAuth();

    const legendGraphics = weatherOptions.filter((option) => {
        const layer = userProfileSettings?.layers?.weather_radar.find((weather) => {
            return option.name.toLowerCase() === weather.weather_name.toLowerCase();
        });
        return option.legendUrl && layer?.visible ? true : false;
    });
    return (
        <Box
            sx={{
                position: "absolute",
                bottom: { xs: "32px", sm: "16px" },
                left: "16px",
                display: "flex",
                flexDirection: "column",
                gap: 2,
                maxWidth: { xs: "calc(100% - 32px)", sm: "500px" },
                width: "100%"
            }}
        >
            {legendGraphics.map(({ name, legendUrl }, i) => {
                const encodedUrl = encodeURIComponent(legendUrl);
                return <Box key={i} component="img" src={`/truweather/wmts/getLegend/${encodedUrl}`} alt={`Legend for ${name}`} />;
            })}
        </Box>
    );
};

export default WeatherLegendComponents;
